/**
 * The church's recurring weekly service schedule, and helpers for turning
 * it into real upcoming dates in Pacific time ("Cali time" - the church is
 * in Santa Ana, CA).
 */
import {
  fridayServiceTimeString,
  sundayEveningServiceTimeString,
  sundayMorningServiceTimeString,
  thursdayServiceTimeString,
  tuesdayServiceTimeString,
} from "../constants";
import { newMomentDay } from "./dateHelper";

/**
 * dayOfWeek follows moment's convention: 0 = Sunday ... 6 = Saturday.
 * hour/minute are in 24-hour Pacific time.
 */
export const WEEKLY_SCHEDULE = [
  {
    dayOfWeek: 0,
    hour: 10,
    minute: 0,
    displayTime: "10:00 AM",
    nameString: sundayMorningServiceTimeString,
  },
  {
    dayOfWeek: 0,
    hour: 18,
    minute: 0,
    displayTime: "6:00 PM",
    nameString: sundayEveningServiceTimeString,
  },
  {
    dayOfWeek: 2,
    hour: 19,
    minute: 0,
    displayTime: "7:00 PM",
    nameString: tuesdayServiceTimeString,
  },
  {
    dayOfWeek: 4,
    hour: 19,
    minute: 0,
    displayTime: "7:00 PM",
    nameString: thursdayServiceTimeString,
  },
  {
    dayOfWeek: 5,
    hour: 19,
    minute: 30,
    displayTime: "7:30 PM",
    nameString: fridayServiceTimeString,
  },
];

/**
 * Returns the next `count` upcoming service occurrences, computed from the
 * recurring weekly schedule against the current date/time in Pacific time.
 * Each result is one of the WEEKLY_SCHEDULE entries plus a `date` (a moment
 * in Pacific time) for that specific upcoming occurrence.
 */
export const getUpcomingServices = (count = 3, now = newMomentDay()) => {
  const upcoming = [];

  for (let dayOffset = 0; dayOffset < 14 && upcoming.length < count; dayOffset++) {
    const day = now.clone().add(dayOffset, "days");
    const todaysServices = WEEKLY_SCHEDULE.filter(
      (service) => service.dayOfWeek === day.day()
    );

    todaysServices.forEach((service) => {
      const occurrence = day
        .clone()
        .set({
          hour: service.hour,
          minute: service.minute,
          second: 0,
          millisecond: 0,
        });

      if (occurrence.isAfter(now)) {
        upcoming.push({ ...service, date: occurrence });
      }
    });
  }

  return upcoming.sort((a, b) => a.date - b.date).slice(0, count);
};
